export type ReturnStatus = 'DRIVER_RECEIVED' | 'PENDING_VERIFICATION' | 'VERIFIED' | 'COMPLETED' | 'RELEASED_FOR_CREDIT'
export type ReturnPartStatus = 'DRIVER_RECEIVED' | 'PENDING' | 'VERIFIED' | 'REJECTED'

export enum ReturnStatusEnum {
  DRIVER_RECEIVED = 'Driver Received',
  PENDING_VERIFICATION = 'Pending Verification',
  VERIFIED = 'Verified',
  COMPLETED = 'Completed',
  RELEASED_FOR_CREDIT = 'RELEASED_FOR_CREDIT'
}

export enum PartStatus {
  DRIVER_RECEIVED = 'Driver Received',
  PENDING = 'Pending',
  VERIFIED = 'Verified',
  REJECTED = 'Rejected'
}

export type DigitalReturnDTO ={
    returnId: number
    storeNumber: string
    customerNumber?: string
    returnPartDTOs?: ReturnPartDTO[]
    returnStatus: ReturnStatus
    returnInvoiceNumber: string
    updatedBy: string
    createdBy: string
    creationTimestamp: number
    updatedTimestamp: number | null
    completionTimestamp: number | null
    signature: string
    signaturePrintName: string
    customerName: string
    email: string
}

export type ReturnPartDTO = {
    partId: number
    productLine: string
    partNumber: string
    description: string
    qty: number
    partType: string
    notes: string
    partStatus: ReturnPartStatus
    updatedBy: string
    updatedTimestamp: number | null
    isPartScanned: boolean
}